export const downloadFile = (url, filename) => {
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);  // Required for Firefox
    link.click();
    document.body.removeChild(link);
}